var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5V3.5C5 2.94772 5.44772 2.5 6 2.5H14C14.5523 2.5 15 2.94772 15 3.5V6.5",
    stroke: "#5E666E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0001 5.84998C2.53654 5.84998 1.3501 7.03642 1.3501 8.49998V12.5C1.3501 13.9635 2.53654 15.15 4.0001 15.15H5.0001V13.85H4.0001C3.25451 13.85 2.6501 13.2456 2.6501 12.5V8.49998C2.6501 7.75439 3.25451 7.14998 4.0001 7.14998H16.0001C16.7457 7.14998 17.3501 7.75439 17.3501 8.49998V12.5C17.3501 13.2456 16.7457 13.85 16.0001 13.85H15.0001V15.15H16.0001C17.4637 15.15 18.6501 13.9635 18.6501 12.5V8.49998C18.6501 7.03642 17.4637 5.84998 16.0001 5.84998H4.0001Z",
    fill: "#5E666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5H6C5.44772 11.5 5 11.9477 5 12.5V16.5C5 17.0523 5.44772 17.5 6 17.5H14C14.5523 17.5 15 17.0523 15 16.5V12.5C15 11.9477 14.5523 11.5 14 11.5Z",
    stroke: "#5E666E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.48fc073234542bdbeda8cc9a5a11670a.svg";
export { ForwardRef as ReactComponent };